// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DjtrBQbcKYwKh8NC,.VFOJ2gFjvCM0XGiW .Eg_nSdvo8vElIMAg{border-radius:1000px}.KGsvTkJNBgYtjRAS{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.fw2POLV2KYMyGDLA{display:flex;flex-direction:column;justify-content:center;align-items:center}.uWXaDNUW20YEEdUs{animation:MdFNjqnj2y4MPjDL 3s infinite;animation-iteration-count:infinite}@keyframes MdFNjqnj2y4MPjDL{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.VFOJ2gFjvCM0XGiW{display:flex;column-gap:8px;align-items:center}.VFOJ2gFjvCM0XGiW .s4rEQdyaRsofv1ho{flex-shrink:1}.VFOJ2gFjvCM0XGiW .Eg_nSdvo8vElIMAg{flex-shrink:0;min-width:16px;height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `DjtrBQbcKYwKh8NC`,
	"outlookOption": `VFOJ2gFjvCM0XGiW`,
	"outlookColor": `Eg_nSdvo8vElIMAg`,
	"text-truncate": `KGsvTkJNBgYtjRAS`,
	"shaquille": `fw2POLV2KYMyGDLA`,
	"shimmer": `uWXaDNUW20YEEdUs`,
	"placeHolderShimmer": `MdFNjqnj2y4MPjDL`,
	"outlookTitle": `s4rEQdyaRsofv1ho`
};
export default ___CSS_LOADER_EXPORT___;
